import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-8">
           {" "}
      <div className="container mx-auto text-center">
                <p>&copy; 2025 Tours. Todos los derechos reservados.</p>
               {" "}
        <div className="flex justify-center space-x-4 mt-4">
                   {" "}
          <a href="tel:+591..." className="hover:underline">
            Llamar
          </a>
                   {" "}
          <a href="mailto:..." className="hover:underline">
            Enviar Correo
          </a>
                    https://wa.me/591...        {" "}
        </div>
             {" "}
      </div>
         {" "}
    </footer>
  );
};

export default Footer;
